import get from 'lodash/get';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '../../FormControl/FormControl';
import { FieldArgs, ScoreField } from '../types';
import { useFormError } from '../utils';
import RadioGroup from '../../RadioGroup/RadioGroup';
import Radio from '../../Radio/Radio';
import InputLabel from '../../InputLabel/InputLabel';
import FormError from '../../FormError/FormError';

export type Props = FieldArgs<ScoreField>;

const ScoreAdapter = (props: Props) => {
  const { label, name, rules, disabled, defaultValue } = props;
  const { control, formState } = useFormContext();
  const error = useFormError(get(formState.errors, name));

  // Generate scores from 1 to 10
  const scores = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <FormControl error={!!error} disabled={disabled}>
      {label && <InputLabel>{label}</InputLabel>}
      <Controller
        name={name}
        rules={rules}
        control={control}
        disabled={disabled}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => {
          return (
            <RadioGroup onChange={onChange} value={value} name={name} row>
              {scores.map((score) => (
                <Radio
                  id={`${name}_${score}`}
                  value={score}
                  label={score.toString()}
                  key={score}
                  variant="button"
                  checked={+value === +score}
                />
              ))}
            </RadioGroup>
          );
        }}
      />
      <FormError error={error} />
    </FormControl>
  );
};

export default ScoreAdapter;
